module.exports = __webpack_public_path__ + "static/media/8788.0e030c3c.png";